import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Tooltip from 'base/components/Tooltip/Tooltip';
import theme from '../../theme';

const ToolbarButtonBase = styled.a`
font-size: 20px;
  padding: 2px;
  display: inline-block;
  color: ${theme.colors.mediumlight};
  &:hover {
    color ${theme.colors.primary};
    cursor: pointer;
  }
  ${(props) => props.isActive && css`
    color ${theme.colors.primary};
  `};
`;
ToolbarButtonBase.propTypes = {
  isActive: PropTypes.bool,
};
ToolbarButtonBase.defaultProps = {
  isActive: false,
};


const ToolbarButton = ({
  editor, type, icon, onClick, isActive, label,
}) => {
  const button = (
    <ToolbarButtonBase
      isActive={isActive}
      onMouseDown={(event) => onClick(event, type, editor)}
    >
      {icon}
    </ToolbarButtonBase>
  );
  return label && label !== ''
    ? <Tooltip content={label}>{button}</Tooltip>
    : button;
};
ToolbarButton.propTypes = {
  isActive: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  label: PropTypes.string,
};
ToolbarButton.defaultProps = {
  onClick: () => {},
  isActive: false,
  label: '',
};

export default ToolbarButton;
